import { usePathname } from "next/navigation";

export default function useHasSubNav() {
  const pathName = usePathname();
  return {
    hasSubNav:
      pathName.startsWith("/for-sale")
  };
}
